import { ConsultationCard, Consultation } from 'types';

export const isRpc = (consultation: Consultation | ConsultationCard | undefined): boolean =>
  consultation?.consultationType === 'RPC';
